<!-- Learn With Kalpita Hero Banner -->
<div class="learn-kalpita-bg">
  <section class="learn-kalpita-section container py-5">
    <div class="glass-panel-container learn-glass">
      <div class="row align-items-center">
        
        <!-- Left Text Section -->
        <div class="col-lg-3 col-md-4 learn-text">
          <h2 class="learn-heading">Learn With</h2>
          <h1 class="learn-subheading">KALPITA</h1>
        </div>

        <!-- Right Video Section -->
        <div class="col-lg-9 col-md-8 text-center learn-media">
          <video
            #heroVideo
            preload="auto"
            src="../../../../assets/gallery-page/learn-with-kalpita/learnwithkalpita.webm"
            class="learn-hero-video"
            autoplay
            loop
            muted
            playsinline
            disablePictureInPicture>
          </video>
        </div>

      </div>
    </div>
  </section>
</div>

<!-- Tech Talk Section -->
<section class="tech-talk-section py-5">
  <div class="container">
    <h2 class="section-title text-center mb-5">Tech Talk</h2>

    <div class="d-flex align-items-center position-relative">
      <!-- Left Arrow -->
      <button class="carousel-arrow-btn left" (click)="techTalkSlide('prev')"
        [disabled]="techTalkCurrentCenterIndex === 0">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Videos Grid Wrapper -->
      <div class="videos-grid-wrapper">
        <div class="videos-row single-row">
          <div class="video-card" *ngFor="let v of techTalkCurrentSlideVideos; let i = index"
            (click)="openVideoModal(v)">
            <div class="video-thumbnail-wrapper">
              <img [src]="v.thumbnail" [alt]="v.title" class="video-thumbnail" />
              <div class="play-overlay">
                <svg width="80" height="80" viewBox="0 0 80 80" class="play-icon">
                  <circle cx="40" cy="40" r="38" fill="rgba(255, 255, 255, 0.9)" stroke="rgba(0, 0, 0, 0.1)"
                    stroke-width="2" />
                  <polygon points="32,25 32,55 55,40" fill="#016096" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button class="carousel-arrow-btn right" (click)="techTalkSlide('next')"
        [disabled]="techTalkCurrentCenterIndex >= techTalkVideos.length - visibleCount">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Carousel Dots -->
    <div class="carousel-dots" *ngIf="shouldShowDots(techTalkVideos)">
      <span *ngFor="let _ of createArray(techTalkDotCount); let di = index" class="dot"
        [class.active]="di === getTechTalkActiveDot()" (click)="onTechTalkDotClick(di)">
      </span>
    </div>
  </div>
</section>

<!-- Training Section -->
<section class="tech-talk-section training-section py-5">
  <div class="container">
    <h2 class="section-title text-center mb-5">Training</h2>

    <div class="d-flex align-items-center position-relative">
      <!-- Left Arrow -->
      <button class="carousel-arrow-btn left" (click)="trainingSlide('prev')"
        [disabled]="trainingCurrentCenterIndex === 0">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Videos Grid Wrapper -->
      <div class="videos-grid-wrapper">
        <div class="videos-row single-row">
          <div class="video-card" *ngFor="let v of trainingCurrentSlideVideos; let i = index"
            (click)="openVideoModal(v)">
            <div class="video-thumbnail-wrapper">
              <img [src]="v.thumbnail" [alt]="v.title" class="video-thumbnail" />
              <div class="play-overlay">
                <svg width="80" height="80" viewBox="0 0 80 80" class="play-icon">
                  <circle cx="40" cy="40" r="38" fill="rgba(255, 255, 255, 0.9)" stroke="rgba(0, 0, 0, 0.1)"
                    stroke-width="2" />
                  <polygon points="32,25 32,55 55,40" fill="#016096" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button class="carousel-arrow-btn right" (click)="trainingSlide('next')"
        [disabled]="trainingCurrentCenterIndex >= trainingVideos.length - visibleCount">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Carousel Dots -->
    <div class="carousel-dots" *ngIf="shouldShowDots(trainingVideos)">
      <span *ngFor="let _ of createArray(trainingDotCount); let di = index" class="dot"
        [class.active]="di === getTrainingActiveDot()" (click)="onTrainingDotClick(di)">
      </span>
    </div>
  </div>
</section>

<!-- Brown Bag Section -->
<section class="tech-talk-section py-5">
  <div class="container">
    <h2 class="section-title text-center mb-5">Brown Bag</h2>

    <div class="d-flex align-items-center position-relative">
      <!-- Left Arrow -->
      <button class="carousel-arrow-btn left" (click)="brownbagSlide('prev')"
        [disabled]="brownbagCurrentCenterIndex === 0">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Videos Grid Wrapper -->
      <div class="videos-grid-wrapper">
        <div class="videos-row single-row">
          <div class="video-card" *ngFor="let v of brownbagCurrentSlideVideos; let i = index"
            (click)="openVideoModal(v)">
            <div class="video-thumbnail-wrapper">
              <img [src]="v.thumbnail" [alt]="v.title" class="video-thumbnail" />
              <div class="play-overlay">
                <svg width="80" height="80" viewBox="0 0 80 80" class="play-icon">
                  <circle cx="40" cy="40" r="38" fill="rgba(255, 255, 255, 0.9)" stroke="rgba(0, 0, 0, 0.1)"
                    stroke-width="2" />
                  <polygon points="32,25 32,55 55,40" fill="#016096" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button class="carousel-arrow-btn right" (click)="brownbagSlide('next')"
        [disabled]="brownbagCurrentCenterIndex >= brownbagVideos.length - visibleCount">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Carousel Dots -->
    <div class="carousel-dots" *ngIf="shouldShowDots(brownbagVideos)">
      <span *ngFor="let _ of createArray(brownbagDotCount); let di = index" class="dot"
        [class.active]="di === getBrownbagActiveDot()" (click)="onBrownbagDotClick(di)">
      </span>
    </div>
  </div>
</section>

<!-- Coding Tutorial Section -->
<section class="tech-talk-section coding-tutorial-section py-5">
  <div class="container">
    <h2 class="section-title text-center mb-5">Coding Tutorial</h2>

    <div class="d-flex align-items-center position-relative">
      <!-- Left Arrow -->
      <button class="carousel-arrow-btn left" (click)="codingtutorialSlide('prev')"
        [disabled]="codingtutorialCurrentCenterIndex === 0">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Videos Grid Wrapper -->
      <div class="videos-grid-wrapper">
        <div class="videos-row single-row">
          <div class="video-card" *ngFor="let v of codingtutorialCurrentSlideVideos; let i = index"
            (click)="openVideoModal(v)">
            <div class="video-thumbnail-wrapper">
              <img [src]="v.thumbnail" [alt]="v.title" class="video-thumbnail" />
              <div class="play-overlay">
                <svg width="80" height="80" viewBox="0 0 80 80" class="play-icon">
                  <circle cx="40" cy="40" r="38" fill="rgba(255, 255, 255, 0.9)" stroke="rgba(0, 0, 0, 0.1)"
                    stroke-width="2" />
                  <polygon points="32,25 32,55 55,40" fill="#016096" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button class="carousel-arrow-btn right" (click)="codingtutorialSlide('next')"
        [disabled]="codingtutorialCurrentCenterIndex >= codingtutorialVideos.length - visibleCount">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Carousel Dots -->
    <div class="carousel-dots" *ngIf="shouldShowDots(codingtutorialVideos)">
      <span *ngFor="let _ of createArray(codingtutorialDotCount); let di = index" class="dot"
        [class.active]="di === getCodingTutorialActiveDot()" (click)="onCodingTutorialDotClick(di)">
      </span>
    </div>
  </div>
</section>

<!-- Video Modal -->
<div class="video-modal-overlay" *ngIf="showVideoModal" (click)="closeVideoModal()">
  <div class="video-modal-container" (click)="$event.stopPropagation()">
    <button class="modal-close-btn" (click)="closeVideoModal()">
      <i class="fas fa-times"></i>
    </button>

    <iframe *ngIf="currentModalVideo?.safeUrl" class="modal-video-iframe" [src]="currentModalVideo?.safeUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen referrerpolicy="strict-origin-when-cross-origin">
    </iframe>

    <div class="modal-video-title">{{ currentModalVideo?.title }}</div>
  </div>
</div>